module.exports = __webpack_public_path__ + "static/media/chevron-left.2bc6bc01.svg";